import { set } from "dot-object";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { ReduxActionTypes } from "legacy/constants/ReduxActionConstants";
import { mergeUpdatesWithBindingsOrTriggers } from "legacy/utils/DynamicBindingUtils";
import { Flag } from "store/slices/featureFlags";
import { fastClone } from "utils/clone";
import { NOOP } from "utils/function";
import { routeIcon } from "../../Explorer/ExplorerIcons";
import { ItemTypeNonWidget } from "../ItemKindConstants";
import type { ItemKinds } from "../ItemKindConstants";
import type { ItemKindAccessor } from "../ItemKinds";
import type { ApplicationScope, RouteDef } from "@superblocksteam/shared";
import type { Dispatch } from "redux";
import type { Flags } from "store/slices/featureFlags/models/Flags";
import type { AppState } from "store/types";

export const RouteAccessor: ItemKindAccessor<ItemKinds.ROUTE> = {
  useItemName: (itemProperties) =>
    useMemo(() => {
      return {
        name: itemProperties.path,
        editable: false,
        requiresValidation: true,
      };
    }, [itemProperties.path]),
  itemType: (itemProperties) => ItemTypeNonWidget.ROUTE,
  useItemProperties: (itemId: string) => {
    return useSelector(
      (state: AppState) => state.legacy.entities.app.routes[itemId] ?? {},
    );
  },
  updateItemProperties: (
    dispatch: Dispatch,
    properties: RouteDef,
    updates: Record<string, unknown>,
    itemScope: ApplicationScope,
    flags: Flags,
  ) => {
    const changes = fastClone(properties);

    const updatesWithBindings = mergeUpdatesWithBindingsOrTriggers(
      properties,
      [],
      updates,
      flags[Flag.ENABLE_DEEP_BINDINGS_PATHS],
    );
    for (const [key, value] of Object.entries(updatesWithBindings)) {
      set(key, value, changes);
    }

    dispatch({
      type: ReduxActionTypes.UPDATE_ROUTE_PROPERTIES,
      payload: { [properties.id]: changes },
    });
  },
  deleteItemProperties: NOOP,
  deleteItem: (dispatch, itemId: string) => {
    dispatch({
      type: ReduxActionTypes.SET_DELETE_ROUTE_CONFIRMATION_MODAL,
      payload: {
        show: true,
        routeId: itemId,
      },
    });
  },
  icon: () => routeIcon,
};
